module.exports = __webpack_public_path__ + "img/icon-sti-dest.e00762c6.svg";